// extracted by mini-css-extract-plugin
module.exports = {"questions":"promo-questions_questions__Q1y05","link":"promo-questions_link__2GruP"};